import React from 'react';

import { AllSystemProps, allSystemProps } from 'shared/styles/props';

import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export interface TypographyProps extends AllSystemProps {
  className?: string;
  style?: React.CSSProperties;
  ellipsis?: boolean;
}

export const RootStyled = styled.div<AllSystemProps>(({ ...rest }) => ({
  height: `1em`,
  padding: 'calc(1em * 0.075) 0',
  width: '100px',
  ...allSystemProps(rest),
}));

const shine = keyframes`
    to {
        background-position-x: -200%;
    }
`;

export const SkeletonStyled = styled.div`
  width: 100%;
  height: 100%;
  background: #9fa4b4;
  background: linear-gradient(110deg, #9fa4b4 8%, #adb2c1 18%, #9fa4b4 33%);
  border-radius: 16px;
  background-size: 200% 100%;
  animation: 1.5s ${shine} linear infinite;
`;

export const Skeleton = (props: AllSystemProps) => (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <RootStyled {...(props as unknown as any)}>
    <SkeletonStyled />
  </RootStyled>
);
